export default __webpack_public_path__ + "static/media/gallery_01.0983d0f2.jpg";